import React from "react";
// eslint-disable-next-line no-restricted-imports
import { Slide, useScrollTrigger } from "@material-ui/core";

function HideOnScroll({ children }: { children: React.ReactElement }) {
    const trigger = useScrollTrigger();

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children}
        </Slide>
    );
}

export default HideOnScroll;
